export function buildCSV(items: Array<{ date?: string; platform?: string; caption?: string; media_url?: string }>): string {
  const headers = ['date', 'platform', 'caption', 'media_url'];
  const rows = items.map(it => [it.date, it.platform, (it.caption || '').replace(/\n/g, ' '), it.media_url || '']);
  return [headers.join(','), ...rows.map(r => r.map(c => `"${String(c).replace(/"/g, '""')}"`).join(','))].join('\n');
}

export function downloadCSV(items: Array<any>, filename = 'calendar.csv') {
  const csv = buildCSV(items);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function formatDateForICS(dateStr: string): string {
  const d = new Date(dateStr);
  return d.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
}

export function buildICS(items: Array<{ date?: string; caption?: string; platform?: string }>): string {
  const events = items.map((it, idx) => {
    const dateStr = it.date ?? new Date().toISOString();
    const dtstart = formatDateForICS(dateStr);
    const dtend = formatDateForICS(new Date(new Date(dateStr).getTime() + (60*60*1000)).toISOString());
    const uid = `floai-${Date.now()}-${idx}`;
    const summary = (it.caption || '').split('\n')[0] || `${it.platform} post`;
    const description = (it.caption || '').replace(/\n/g,'\\n');
    return [
      'BEGIN:VEVENT',
      `UID:${uid}`,
      `DTSTAMP:${dtstart}`,
      `DTSTART:${dtstart}`,
      `DTEND:${dtend}`,
      `SUMMARY:${summary}`,
      `DESCRIPTION:${description}`,
      'END:VEVENT'
    ].join('\r\n');
  }).join('\r\n');

  return ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//floai//CalendarTemplates//EN', events, 'END:VCALENDAR'].join('\r\n');
}

export function downloadICS(items: Array<any>, filename = 'calendar.ics') {
  const ics = buildICS(items);
  const blob = new Blob([ics], { type: 'text/calendar' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
